// components/common/VerifiedBadge.tsx
// Small "verified trader" seal for the bottom-right corner of an avatar.
// Single source of truth for the badge markup so it looks identical everywhere.
//
// Usage: drop inside a `position: relative` avatar container:
//   <div className="relative ...">{avatar}{isVerifiedTier(tier) && <VerifiedBadge size={16} />}</div>

// Which User.verificationTier values count as "verified" for the badge.
// LIVE_VERIFIED = live broker-verified track record. SIMULATED / none do NOT qualify.
export const VERIFIED_TIERS = ['LIVE_VERIFIED'] as const;
export function isVerifiedTier(tier?: string | null): boolean {
  return !!tier && (VERIFIED_TIERS as readonly string[]).includes(tier);
}

export default function VerifiedBadge({
  size = 16,
  className = '',
}: {
  /** Seal diameter in px. */
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`absolute -bottom-0.5 -right-0.5 inline-flex items-center justify-center pointer-events-none ${className}`}
      style={{ width: size, height: size }}
      title="Verified trader"
      aria-label="Verified trader"
      role="img"
    >
      <svg viewBox="0 0 24 24" width={size} height={size}>
        {/* Dark ring so the seal reads on any avatar / background */}
        <circle cx="12" cy="12" r="11" fill="#0d0f14" />
        <circle cx="12" cy="12" r="9" className="fill-emerald-400" fill="#34d399" />
        <path
          d="m8 12.2 2.6 2.6 5-5.2"
          fill="none"
          stroke="#0d0f14"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
